import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { Shell } from '../components/Shell';

/** Pathless layout route (the leading `_` per TanStack Router's "Authenticated
 * Routes" convention) gating every screen-group route nested in
 * src/routes/_authenticated/. `beforeLoad` runs before any child route's own
 * loader, so an unauthenticated visit never reaches a protected screen — it
 * redirects to /login and remembers where the user was headed. */
export const Route = createFileRoute('/_authenticated')({
  beforeLoad: ({ context, location }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({ to: '/login', search: { redirect: location.href } });
    }
  },
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  return (
    <Shell>
      <Outlet />
    </Shell>
  );
}
